<template>
  <div>
    <div class="menuStyle py-3">
      <v-container id="menuResponsive">
        <v-row>
          <v-btn @click.stop="drawer = !drawer" class="ml-3 my-3"><v-icon>mdi-menu</v-icon></v-btn>
          <v-navigation-drawer v-model="drawer" absolute temporary width="280">
            
            <div style="background-color: #1c3d6c" class="py-4 pl-2">
              <v-list-item>
                <v-list-item-avatar>
                    <v-img src="@/assets/logo-fq-gold.png"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title style="color: white">OLIMPIADA DE QUIMICA</v-list-item-title>
                </v-list-item-content>
              </v-list-item>  
            </div>
            <v-list dense> 
              <v-list-item-group color="primary"> 
                  <!-- <v-divider></v-divider> -->
                  <v-list-item to="/">
                      <v-list-item-icon>
                          <v-icon>mdi-home-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                          <v-list-item-title>INICIO</v-list-item-title>
                      </v-list-item-content>
                  </v-list-item>

                  <v-list-group prepend-icon="mdi-pencil-outline">
                    <template v-slot:activator>
                      <v-list-item-title>PARTICIPA</v-list-item-title>
                    </template>
                    <v-list dense>
                      <v-list-item v-for="(item, index) in itemsParticipa" :key="index" link :to="item.enlace">
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-list-group>

                  <v-list-group prepend-icon="mdi-domain">
                    <template v-slot:activator>
                      <v-list-item-title>LA OQCDMX</v-list-item-title>
                    </template>
                    <v-list dense>
                      <v-list-item v-for="(item, index) in itemsOQCDMX" :key="index" link :to="item.enlace">
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-list-group>

                  <v-list-group prepend-icon="mdi-medal-outline">
                    <template v-slot:activator>
                      <v-list-item-title>OLIMPIADAS</v-list-item-title>
                    </template>
                    <v-list dense>
                      <v-list-item v-for="(item, index) in itemsOlimpiadas" :key="index" link :to="item.enlace">
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item href="https://olquim.mx" target="_blank" rel="noopener noreferrer">
                        <v-list-item-title>NACIONAL</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-list-group>

                  <v-list-item to="/material">
                      <v-list-item-icon>
                          <v-icon>mdi-pencil-box-multiple-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                          <v-list-item-title>MATERIAL</v-list-item-title>
                      </v-list-item-content>
                  </v-list-item>

                  <v-list-item to="/contacto">
                      <v-list-item-icon>
                          <v-icon>mdi-account-box-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                          <v-list-item-title>CONTACTO Y FAQ</v-list-item-title>
                      </v-list-item-content>
                  </v-list-item>

                  <v-list-item to="/resultado">
                      <v-list-item-icon>
                          <v-icon>mdi-text-box-check-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                          <v-list-item-title>RESULTADOS</v-list-item-title>
                      </v-list-item-content>
                  </v-list-item>

                  <v-list-item to="/galeria">
                      <v-list-item-icon>
                          <v-icon>mdi-image-multiple-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                          <v-list-item-title>GALERIA</v-list-item-title>
                      </v-list-item-content>
                  </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-navigation-drawer>
        </v-row>
      </v-container>

      <v-container id="menuBase">
        <v-row justify="center">
          <v-btn-toggle> 

            <v-btn to="/"><v-icon left>mdi-home-outline</v-icon>INICIO</v-btn>
            
            <v-menu offset-y>
        
            <template v-slot:activator="{ on, attrs }">
              <v-btn
               v-bind="attrs"
               v-on="on"
              ><v-icon left>mdi-pencil-outline</v-icon>
                PARTICIPA
              </v-btn>
            </template>
            <!-- Submenú liberación -->
            <v-list dense>
             <v-list-item class="text-caption" to="/participa/convocatoria">CONVOCATORIA</v-list-item>
             <v-list-item class="text-caption" to="/participa/inscripcion">INSCRIPCION</v-list-item>
             <v-list-item class="text-caption" to="/participa/sedes">SEDES</v-list-item>
            </v-list>    
          
          </v-menu>

        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
               v-bind="attrs"
               v-on="on"
              ><v-icon left>mdi-domain</v-icon>
                LA OQCDMX
              </v-btn>
            </template>
            <!-- Submenú liberación -->
            <v-list dense>
             <v-list-item class="text-caption" to="/oqcdmx/historia">HISTORIA</v-list-item>
             <v-list-item class="text-caption" to="/oqcdmx/integrantes">INTEGRANTES</v-list-item>
             <v-list-item class="text-caption" to="/oqcdmx/participar">PARTICIPAR</v-list-item>

            </v-list>    

        </v-menu> 
            
            <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
               v-bind="attrs"
               v-on="on"
              ><v-icon left>mdi-medal-outline</v-icon>
                OLIMPIADAS
              </v-btn>
            </template>
            <!-- Submenú liberación -->
            <v-list dense>
             <v-list-item class="text-caption" to="/olimpiadas/iberoamericana">IBEROAMERICANA</v-list-item>
             <v-list-item class="text-caption" to="/olimpiadas/internacional">INTERNACIONAL</v-list-item>
             <v-list-item class="text-caption" href="https://olquim.mx" target="_blank" rel="noopener noreferrer">NACIONAL</v-list-item>

            </v-list>  
          
          </v-menu>

            <v-btn to="/material"><v-icon left>mdi-pencil-box-multiple-outline</v-icon>MATERIAL</v-btn>
            <v-btn to="/contacto"><v-icon left>mdi-account-box-outline</v-icon>CONTACTO Y FAQ</v-btn>
            <v-btn to="/resultado"><v-icon left>mdi-text-box-check-outline</v-icon>RESULTADOS</v-btn>
            <v-btn to="/galeria"><v-icon left>mdi-image-multiple-outline</v-icon>GALERIA</v-btn>

         </v-btn-toggle>
        </v-row>
        
      </v-container>
      <router-view/>
    </div>
  </div>
</template>

<script>

export default {
  name: "Menu",
  data: () =>{
    return {
      drawer: null,
      itemsParticipa: [
        { title: 'CONVOCATORIA', enlace: '/participa/convocatoria'},
        { title: 'INSCRIPCION', enlace: '/participa/inscripcion' },
        { title: 'SEDES', enlace: '/participa/sedes' },
      ],
      itemsOQCDMX: [
        { title: 'HISTORIA', enlace: '/oqcdmx/historia'},
        { title: 'INTEGRANTES', enlace: '/oqcdmx/integrantes' },
        { title: 'PARTICIPAR', enlace: '/oqcdmx/participar' },
      ],
      itemsOlimpiadas: [
        { title: 'IBEROAMERICANA', enlace: '/olimpiadas/iberoamericana'},
        { title: 'INTERNACIONAL', enlace: '/olimpiadas/internacional' },
        // { title: 'NACIONAL', enlace: '/olimpiadas/nacional' },
      ],
    }
  },
}
</script>

<style>
  .menuStyle{
    padding: 5px;
  }
  #buttonUser{
    width: 800px;        
  }
  @media (min-width: 850px){
    #menuResponsive{
      display: none;
    }
  }
  @media (max-width: 849px){
    #menuBase{
      display: none;
    }
  }
</style>

